import { gql, type TypedDocumentNode } from '@apollo/client';
import type {
  MyProfileQuery,
  MyProfileQueryVariables,
} from '@willnq/shared/shared-types/generated/graphql';

import { TALENT_PROFILE_FIELDS } from './fragments';

/**
 * The authenticated candidate's own full profile (Talent.md — GetMyProfileQuery). The
 * `TypedDocumentNode<TData, TVariables>` annotation (types generated by `npm run codegen` from
 * the schema — see fragments.ts) is what gives `useQuery(MY_PROFILE_QUERY)` its inferred `data`
 * type with zero manual generics at the call site.
 */
export const MY_PROFILE_QUERY: TypedDocumentNode<MyProfileQuery, MyProfileQueryVariables> = gql`
  query MyProfile {
    myProfile {
      ...TalentProfileFields
    }
  }
  ${TALENT_PROFILE_FIELDS}
`;

/** Every uploaded resume version, newest first (Talent.md — GetResumeHistoryQuery). */
